import React, { Component } from 'react';
import { render } from '@testing-library/react';
import { Container, Table, Row, Col } from 'react-bootstrap';

class Cv extends Component { 

    state = { displayImprint: false };

    toggleImprint = () => {
        this.setState({ displayImprint: !this.state.displayImprint })
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col><h3>Curriculum Vitae</h3></Col>
                </Row>
                <Row>
                    <Col>
                        <Table>
                            <tr><td rowspan="2"><strong>Persönliches</strong></td><td colspan="2">geboren am 02. Februar 1971 in Freiburg i. Br. </td></tr>
                            <tr><td colspan="2">geschieden, einen Sohn </td></tr>
                            <tr><td rowspan="12"><strong>Erfahrung</strong></td><td colspan="2">SOFTWAREENTWICKLER, ROEDERZEIBIG GMBH & CO KG, HÜNFELDEN</td></tr>
                            <tr><td colspan="2">seit 07/2018</td></tr>
                            <tr><td colspan="2">SOFTWAREENTWICKLER, LAWO GMBH, WIESBADEN</td></tr>
                            <tr><td colspan="2">06/2015 - 06/2018</td></tr>
                            <tr><td colspan="2">SOFTWAREENTWICKLER, PARAGON DATA GMBH, FRIEDRICHSDORF</td></tr>
                            <tr><td colspan="2">11/2005 - 05/2015</td></tr>
                            <tr><td colspan="2">SOFTWAREENTWICKLER, EDS GMBH, LANDAU</td></tr>
                            <tr><td colspan="2">2003 - 10/2005</td></tr>
                            <tr><td colspan="2">SOFTWAREENTWICKLER, ACHT:G WEBSOLUTIONS, RÜSSELSHEIM</td></tr>
                            <tr><td colspan="2">1998 - 2003</td></tr>
                            <tr><td colspan="2">STUDIOMONTEUR, BFE AG, MAINZ</td></tr>
                            <tr><td colspan="2">1993 - 1994</td></tr>
                            <tr><td rowspan="8"><strong>Ausbildung</strong></td><td colspan="2">STUDIENGANG FERNSEHTECHNIK, FH WIESBADEN</td></tr>
                            <tr><td colspan="2">1995 - 2003</td></tr>
                            <tr><td colspan="2">FACHHOCHSCHULREIFE, FACHRICHTUNG ELEKTROTECHNIK, WORMS</td></tr>
                            <tr><td colspan="2">1995</td></tr>
                            <tr><td colspan="2">RADIO- UND FERHSEHTECHNIKER, QUELLE TECHNISCHER KUNDENDIENST, WORMS</td></tr>
                            <tr><td colspan="2">1988 - 1992</td></tr>
                            <tr><td colspan="2">KARMELITER-REALSCHULE, WORMS, QUALIFIZIERTER REALSCHULABSCHLUSS</td></tr>
                            <tr><td colspan="2">1988</td></tr>
                            <tr><td rowspan="2"><strong>Zivildienst</strong></td><td colspan="2">ALTENZENTRUM DER ARBEITERWOHLFAHRT, WORMS</td></tr>
                            <tr><td colspan="2">1992 -1993</td></tr>
                            <tr><td rowspan="2"><strong>Sprachen</strong></td><td colspan="2">Deutsch (Muttersprache)</td></tr>
                            <tr><td colspan="2">Englisch (Wort und Schrift)</td></tr>
                            <tr><td rowspan="2"><strong>Interessen und Engagement</strong></td><td colspan="2">Aikido (aktiv sowie als Kinder- und Jugendtrainer)</td></tr>
                            <tr><td colspan="2">Musik (Gitarre, Bass, Gesang und Komposition)</td></tr>
                        </Table>
                        <br />&nbsp;
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Cv;
